import script from "./CallsHistoryMobileTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CallsHistoryMobileTable.vue?vue&type=script&setup=true&lang=js"

import "./CallsHistoryMobileTable.vue?vue&type=style&index=0&id=4703af2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4703af2c"]])

export default __exports__